import angular from 'angular';
import { MeurhAdmissaocompletaService } from './admissaocompleta.service';

export const MeurhAdmissaocompletaListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider): void {

    let resolve = {
        'entity': [
            'MeurhAdmissaocompletaService',
            '$rootScope',
            '$stateParams',
            '$state',
            '$q',
            function (
                entityService: MeurhAdmissaocompletaService,
                $rootScope: angular.IRootScopeService & { session: any },
                $stateParams: angular.ui.IStateParamsService,
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ): angular.ui.IStateParamsService | angular.IQService | {} {

                if ($stateParams['entity']) {
                    return $stateParams['entity'];
                } else {
                    if ($stateParams['solicitacao']) {
                        return $q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>) => {
                            entityService.get($stateParams['solicitacao'])
                                .then((data: any) => {
                                    const deveRedirecionar = data.estabelecimento !== $rootScope.session.entities.estabelecimento.estabelecimento;
                                    if (deveRedirecionar) {
                                        $state.go('meurh_admissaocompleta');
                                        return;
                                    }
                                    resolve(data);
                                })
                                .catch((error: any) => {
                                    if (error.status === 404) {
                                        if ($state.href('meurh_admissaocompleta_not_found', $stateParams)) {
                                            $state.go('meurh_admissaocompleta_not_found', $stateParams);
                                        } else {
                                            $state.go('not_found', $stateParams);
                                        }
                                    }
                                });
                        });
                    } else {
                        return {};
                    }
                }
            }
        ]
    };

    $stateProvider
        .state('meurh_admissaocompleta', {
            url: '/solicitacoes/admissoes?q?estabelecimento?tipo',
            template: require('html-loader!./index/admissaocompleta.index.html'),
            controller: 'Meurh\AdmissaocompletaIndexController',
            controllerAs: 'mrh_admsscmplt_lst_cntrllr',
            reloadOnSearch: false
        })
        .state('meurh_admissaocompleta_new', {
            url: '/solicitacoes/admissoes/completa/new',
            resolve: resolve,
            template: require('html-loader!./new/admissaocompleta.new.html'),
            controller: 'MeurhAdmissaocompletaNewController',
            controllerAs: 'mrh_admsscmplt_frm_nw_cntrllr'
        })
        .state('meurh_admissaocompleta_show', {
            url: '/solicitacoes/admissoes/completa/show/:solicitacao?path',
            resolve: resolve,
            template: require('html-loader!./show/admissaocompleta.show.html'),
            controller: 'MeurhAdmissaocompletaShowController',
            controllerAs: 'mrh_admsscmplt_frm_shw_cntrllr'
        })
        .state('meurh_admissaocompleta_edit', {
            url: '/solicitacoes/admissoes/completa/edit/:solicitacao?camposobrigatorios',
            resolve: resolve,
            template: require('html-loader!./edit/admissaocompleta.edit.html'),
            controller: 'Meurh\AdmissaocompletaEditController',
            controllerAs: 'mrh_admsscmplt_frm_edit_cntrllr'
        });
    }
];
